import { BookClub } from './bookclub';
import { Icon, Record } from './record';
import { RssItem } from './rss';
import { OtkList } from './user-item-list';

export interface RecordSwipperItem {
  title: string;
  author?: string;
  covers: string[];
  subtitle?: string;
  active?: boolean;
  useMulticover: boolean;
  icon?: Icon;
  id?: string;
  concatenatedCovers?: boolean;
}

export enum SwiperConfigType {
  FEATURED = 'FEATURED',
  USER = 'USER',
  CAREER_PLANS = 'CAREER_PLANS',
}

export class RecordSwipperUtils {
  public static fromRecordToSwiperItem(record: Record): RecordSwipperItem {
    return {
      title: record.title,
      author: record.author,
      subtitle: record.subtitle,
      active: record.active,
      icon: record.icon,
      covers: [record.coverImageUrl],
      concatenatedCovers: Boolean(record?.wishListInfo),
      useMulticover: false,
    };
  }

  public static fromOtkListToSwiperItem(list: OtkList): RecordSwipperItem {
    return {
      title: list.name,
      covers: list.covers,
      useMulticover: true,
    };
  }

  public static fromRssItemToSwiperItem(rssItem: RssItem): RecordSwipperItem {
    return {
      title: rssItem.title,
      covers: [rssItem.cover],
      active: true,
      icon: rssItem.icon,
      useMulticover: false,
    };
  }

  public static fromOleItemToSwiperItem(oleItem: BookClub): RecordSwipperItem {
    return {
      title: oleItem.name,
      covers: [oleItem.cover],
      useMulticover: false,
      id: oleItem.id,
    };
  }
}
